import React from "react";
import PropTypes from "prop-types";

// styles
import { LocationStyled } from "./styles.js";

const Location = ({ singleUploadSelected, onLocationUpdate }) => {
    if (!singleUploadSelected) return null;

    const { location } = singleUploadSelected;

    // TODO: Note: I could not find "location" on the upload object
    // we may need to get this elsewhere?
    // or it could be called something else?

    // TODO: add core <Location /> component? See UPL

    const handleOnLocationUpdate = () => {
        onLocationUpdate &&
            onLocationUpdate({ location: "WIP: Upload Location" });
    };

    if (!location) {
        return null;
    }

    return (
        <LocationStyled onClick={handleOnLocationUpdate}>
            {location}
        </LocationStyled>
    );
};

export default Location;

// prop-types
Location.propTypes = {
    singleUploadSelected: PropTypes.object,
    onLocationUpdate: PropTypes.func
};
